module.exports = __webpack_public_path__ + "static/media/S37_W.2f4008dc.png";